// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
// import useGoogleMaps from "@insite/client-framework/Common/Hooks/useGoogleMaps"; // Starter Custom Code
// import useWarehouseFilterSearch from "@insite/client-framework/Common/Hooks/useWarehouseFilterSearch"; // Starter Custom Code
// import useWarehouseGoogleMarkers from "@insite/client-framework/Common/Hooks/useWarehouseGoogleMarkers"; // Starter Custom Code
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { getGeoCodeFromLatLng } from "@insite/client-framework/Common/Utilities/GoogleMaps/getGeoCodeFromAddress";
import withDynamicGoogleMaps, { HasDynamicGoogleMaps } from "@insite/client-framework/Common/withDynamicGoogleMaps";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadWarehouses from "@insite/client-framework/Store/Components/FindLocationModal/Handlers/LoadWarehouses";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWarehousesDataView } from "@insite/client-framework/Store/Data/Warehouses/WarehousesSelectors";
import translate from "@insite/client-framework/Translate";
import { PaginationModel, WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import AddressInfoCondensedDisplay, {
    AddressInfoCondensedDisplayStyles,
} from "@insite/content-library/Components/AddressInfoCondensedDisplay";
import DistanceDisplay, { DistanceUnitOfMeasure } from "@insite/content-library/Components/DistanceDisplay";
import GoogleMapsDirectionLink from "@insite/content-library/Components/GoogleMapsDirectionLink";
import WarehouseFindLocationPagination from "@insite/content-library/Components/WarehouseFindLocationPagination";
import WarehouseGoogleMap, { WarehouseGoogleMapStyles } from "@insite/content-library/Components/WarehouseGoogleMap";
import WarehouseHoursLink from "@insite/content-library/Components/WarehouseHoursLink";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconMemo, IconPresentationProps } from "@insite/mobius/Icon";
import MapPin from "@insite/mobius/Icons/MapPin";
import Phone from "@insite/mobius/Icons/Phone";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import Radio, { RadioComponentProps } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import parse from "html-react-parser"; // Starter Custom Code
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import InlineFormButton from "@store/Library/Components/Toolkit/InlineFormButton";
import Loader from "@store/Library/Components/Toolkit/Loader";
import { inlineFormWithLabelProps } from "@store/Themes/common/props/inlineForm";
import { locationProps } from "@store/Themes/common/props/location";
import useGoogleMapMarkerIconByType from "@toolkit/Framework/Common/Hooks/googleMap/useGoogleMapMarkerIconByType";
import useGoogleMapThemableMarkers from "@toolkit/Framework/Common/Hooks/googleMap/useGoogleMapThemableMarkers";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import parse from "@toolkit/Framework/Common/Utilities/parseFullPageHtml";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import useGoogleMaps from "@toolkit/Modules/client-framework/Common/Hooks/useGoogleMaps";
import useWarehouseFilterSearch from "@toolkit/Modules/client-framework/Common/Hooks/useWarehouseFilterSearch";
import useWarehouseGoogleMarkers from "@toolkit/Modules/client-framework/Common/Hooks/useWarehouseGoogleMarkers";
/* Starter Custom Code - End */

interface OwnProps {
    modalIsOpen: boolean;
    onWarehouseSelected: (warehouse: WarehouseModel) => void;
    onModalClose: () => void;
    forCart?: boolean;
    extendedStyles?: FindLocationModalStyles;
}

const mapStateToProps = (state: ApplicationState, { forCart }: OwnProps) => {
    const { cartId } = getQueryStrings(state);
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    const pickUpWarehouse = forCart ? cart?.defaultWarehouse : getSession(state).pickUpWarehouse;
    return {
        warehousesDataView: getWarehousesDataView(state, state.components.findLocationModal.getWarehousesParameter),
        pickUpWarehouse,
        settings: getSettingsCollection(state),
    };
};

const mapDispatchToProps = {
    loadWarehouses,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasDynamicGoogleMaps;

export interface FindLocationModalStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    modal?: ModalPresentationProps;
    modalContent?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    form?: InjectableCss;
    searchGridContainer?: GridContainerProps;
    searchTextFieldGridItem?: GridItemProps;
    searchTextField?: TextFieldPresentationProps;
    searchRadiusGridItem?: GridItemProps;
    searchRadiusText?: TextFieldPresentationProps;
    searchButtonGridItem?: GridItemProps;
    searchButton?: ButtonPresentationProps;
    searchResultsTextGridItem?: GridItemProps;
    searchResultsText?: TypographyPresentationProps;
    distanceUnitOfMeasureGridItem?: GridItemProps;
    distanceUnitOfMeasureRadioGroup?: RadioGroupProps;
    distanceUnitOfMeasureImperialRadio?: RadioComponentProps;
    distanceUnitOfMeasureMetricRadio?: RadioComponentProps;
    siteMessageGridItem?: GridItemProps;
    siteMessageGeocodeErrorText?: TypographyPresentationProps;
    siteMessageResultsErrorText?: TypographyPresentationProps;
    searchResultGridItem?: GridItemProps;
    searchResultGridContainer?: GridContainerProps;
    searchResultLeftGridItem?: GridItemProps;
    searchResultWarehouseDetailsGridContainer?: GridContainerProps;
    searchResultDisplayNumberGridItem?: GridItemProps;
    warehouseDisplayNumberText?: TypographyPresentationProps;
    searchResultWarehouseGridItem?: GridItemProps;
    warehouseNameText?: TypographyPresentationProps;
    searchResultAddressInfoOffsetGridItem?: GridItemProps;
    searchResultAddressInfoIcon?: IconPresentationProps;
    searchResultAddressInfoGridItem?: GridItemProps;
    warehouseAddressInfoCondensed?: AddressInfoCondensedDisplayStyles;
    searchResultLinksAndDistanceContainer?: GridContainerProps;
    searchResultPhoneOffsetGridItem?: GridItemProps;
    searchResultPhoneIcon?: IconPresentationProps;
    searchResultPhoneGridItem?: GridItemProps;
    searchResultPhoneLink?: LinkPresentationProps;
    searchResultSelectGridItem?: GridItemProps;
    searchResultSelectButton?: ButtonPresentationProps;
    searchResultLinksOffsetGridItem?: GridItemProps;
    searchResultHoursGridItem?: GridItemProps;
    warehouseHoursLink?: LinkPresentationProps;
    searchResultGoogleMapsDirectionLinkGridItem?: GridItemProps;
    warehouseGoogleMapsDirectionLink?: LinkPresentationProps;
    searchResultDistanceGridItem?: GridItemProps;
    warehouseDistanceDisplayText?: TypographyPresentationProps;
    searchResultDividerGridItem?: GridItemProps;
    searchResultDivider?: InjectableCss;
    paginationGridItem?: GridItemProps;
    pagination?: PaginationPresentationProps;

    rightColumnGridItem?: GridItemProps;
    currentlySelectedGridContainer?: GridContainerProps;
    currentlySelectedHeaderGridItem?: GridItemProps;
    currentlySelectedHeaderText?: TypographyPresentationProps;
    currentlySelectedDetailsGridItem?: GridItemProps;
    selectedWarehouseGridContainer?: GridContainerProps;
    selectedWarehouseDetailsGridItem?: GridItemProps;
    selectedWarehouseNameText?: TypographyPresentationProps;
    selectedWarehouseAddressDisplay?: AddressInfoCondensedDisplayStyles;
    selectedWarehousePhoneLink?: LinkPresentationProps;
    selectedWarehouseLinksGridItem?: GridItemProps;
    selectedWarehouseLink?: LinkPresentationProps;
    selectedWarehouseGoogleMapsDirectionLink?: LinkPresentationProps;
    selectedWarehouseDistanceText?: TypographyPresentationProps;
    warehouseGoogleMapGridItem?: GridItemProps;
    warehouseGoogleMap?: WarehouseGoogleMapStyles;
    warehouseHoursModal?: ModalPresentationProps;
    hoursContainer?: InjectableCss;
    // Starter Custom Code
    searchResultsHeader?: InjectableCss;
    warehouseWrapper?: InjectableCss;
    warehouseInfoWrapper?: InjectableCss;
    warehouseNameWrapper?: InjectableCss;
    warehouseAddressWrapper?: InjectableCss;
    warehouseActionsWrapper?: InjectableCss;
    currentLocationInfoBox?: InfosBoxProps;
    mapWrapper?: InjectableCss;
}

export const findLocationModalStyles: FindLocationModalStyles = {
    modal: { sizeVariant: "large" },
    form: mergeProps<FindLocationModalStyles["form"]>(inlineFormWithLabelProps.wrapper, locationProps.form),
    searchTextField: mergeProps<FindLocationModalStyles["searchTextField"]>(inlineFormWithLabelProps.field, {
        cssOverrides: {
            formField: css`
                flex-grow: 9999;
                width: 100%;

                ${breakpoint("md")} {
                    width: auto;
                }
            `,
        },
    }),
    searchRadiusText: inlineFormWithLabelProps.field,
    searchButton: inlineFormWithLabelProps.button,
    modalContent: locationProps.grid?.container,
    leftColumnGridItem: locationProps.grid?.leftGridItem,
    rightColumnGridItem: locationProps.grid?.rightGridItem,
    searchResultsHeader: locationProps.resultsHeader,
    searchResultsText: locationProps.resultsText,
    distanceUnitOfMeasureRadioGroup: locationProps.distanceRadioGroup,
    siteMessageResultsErrorText: locationProps.noResults,
    siteMessageGeocodeErrorText: locationProps.noResults,
    warehouseWrapper: locationProps.wrapper,
    warehouseInfoWrapper: locationProps.infoWrapper,
    warehouseNameWrapper: locationProps.nameWrapper,
    warehouseNameText: {
        ...locationProps.nameText,
        forwardAs: "h5",
    },
    warehouseDistanceDisplayText: locationProps.distanceText,
    warehouseAddressWrapper: locationProps.addressWrapper,
    warehouseActionsWrapper: locationProps.actionsWrapper,
    warehouseHoursLink: locationProps.actionLink,
    warehouseGoogleMapsDirectionLink: locationProps.actionLink,
    searchResultSelectButton: {
        variant: "tertiary",
        sizeVariant: "small",
    },
    currentLocationInfoBox: {
        type: "success",
        size: "small",
    },
    warehouseHoursModal: locationProps.contentModal,
    hoursContainer: locationProps.contentModalWrapper,
    mapWrapper: mergeProps<FindLocationModalStyles["mapWrapper"]>(locationProps.mapWrapper, {
        css: css`
            max-height: calc(100vh - ${pxToRem(195)});
        `,
    }),
};

const StyledForm = getStyledWrapper("form");
// Starter Removed - StyledHr

let lastFocusableElement: any = null;

const FindLocationModal = ({
    pickUpWarehouse,
    settings,
    warehousesDataView,
    modalIsOpen,
    onWarehouseSelected,
    onModalClose,
    extendedStyles,
    loadWarehouses,
    useLoadScript,
}: Props) => {
    const styles = useMergeProps(findLocationModalStyles, extendedStyles); // Starter Custom Code
    const [distanceUnitOfMeasure, setDistanceUnitOfMeasure] = useState<DistanceUnitOfMeasure>("Imperial");
    const [warehouseHoursToDisplay, setWarehouseHoursToDisplay] = useState<WarehouseModel | undefined>(undefined);
    const [warehouseHoursToDisplayModalOpen, setWarehouseHoursToDisplayModalOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    /* Starter Custom Code - Start */
    const MarkerIcon = useGoogleMapMarkerIconByType("LOCATION");
    const settingsRadiusRef = React.useRef<number>();
    const [radiusSearch, setRadiusSearch] = React.useState("");
    const [warehouseSearch, setWarehouseSearch] = React.useState("");

    const locationIsWarehouse = () => {
        if (!warehousesDataView.value) {
            return false;
        }

        return (
            selectedWarehouse?.latitude === warehousesDataView.defaultLatitude &&
            selectedWarehouse?.longitude === warehousesDataView.defaultLongitude
        );
    };

    const handleSearchWarehouseBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.value && !locationIsWarehouse()) {
            setWarehouseSearch(warehouseSearchFilter);
        }
    };
    /* Starter Custom Code - End */

    const { googleMapsApiKey } = settings.websiteSettings;
    const { isLoaded } = useLoadScript({ googleMapsApiKey });
    const {
        googleMap,
        setGoogleMap,
        currentLocation,
        setCurrentLocation,
        isGoogleMapsScriptsLoaded,
        setBounds,
        setMapCenter,
        locationKnown,
        setLocationKnown,
    } = useGoogleMaps({
        isLoaded,
        isShown: modalIsOpen,
    });

    // Manage Selected Warehouse
    const [selectedWarehouse, setSelectedWarehouse] = useState<WarehouseModel | undefined>(undefined);
    const [showSelectedWarehouse, setShowSelectedWarehouse] = useState<boolean>(false);
    const [defaultRadius, setDefaultRadius] = useState<number>(0);
    useEffect(() => {
        setSelectedWarehouse(pickUpWarehouse || undefined);
    }, [pickUpWarehouse]);

    // Manage Local Warehouses
    const [warehouses, setWarehouses] = useState<WarehouseModel[]>([]);
    const [resultCount, setResultCount] = useState<number>(0);
    const [warehousesPagination, setWarehousesPagination] = useState<PaginationModel | undefined>();

    // Manage Loading Warehouses on State Changes
    const {
        doSearch,
        warehouseSearchFilter,
        setWarehouseSearchFilter,
        radiusSearchFilter,
        setRadiusSearchFilter,
        setPage,
        setPageSize,
    } = useWarehouseFilterSearch({
        loadWarehouses,
        currentLocation,
        setCurrentLocation,
        setLocationKnown,
        defaultRadius,
        selectedWarehouse,
        setSelectedWarehouse,
        setShowSelectedWarehouse,
        excludeCurrentPickupWarehouse: false, // Starter Custom Code
    });

    // Manage Bounds of Map
    useEffect(() => {
        const bounds = [];
        closeInfoWindows();
        warehouses.forEach(warehouse => {
            bounds.push({ lat: warehouse.latitude, lng: warehouse.longitude });
        });
        // Starter Removed - showSelectedWarehouse && selectedWarehouse
        /* Starter Custom Code - Start */
        if (currentLocation) {
            const currentLocationBound = { lat: currentLocation.lat(), lng: currentLocation.lng() };
            if (currentLocationBound.lat && currentLocationBound.lng) {
                bounds.push(currentLocationBound);
            }
        }
        /* Starter Custom Code - End */
        setBounds(bounds);
    }, [googleMap, warehouses, selectedWarehouse, showSelectedWarehouse, currentLocation]);

    // Manage Map Markers
    const {
        mapMarkersElements: baseMapMarkersElements, // Starter Custom Code
        currentLocationInfoWindow,
        warehouseInfoWindow,
        closeInfoWindows,
        getWarehouseNumber,
    } = useWarehouseGoogleMarkers({
        warehouses,
        warehouseSearchFilter,
        warehousesPagination,
        currentLocation,
        selectedWarehouse,
        showSelectedWarehouse,
    });
    const mapMarkersElements = useGoogleMapThemableMarkers(baseMapMarkersElements.filter(x => x.type !== "SELECTED")); // Starter Custom Code

    useEffect(() => {
        if (!isGoogleMapsScriptsLoaded) {
            return;
        }
        if (warehousesDataView.value && !warehousesDataView.isLoading) {
            const {
                pagination,
                value: warehouses,
                defaultRadius,
                defaultLatitude,
                defaultLongitude,
            } = warehousesDataView;

            /* Starter Custom Code - Start */
            if (!settingsRadiusRef.current) {
                settingsRadiusRef.current = defaultRadius;
            }

            setWarehouseSearch(warehouseSearchFilter);
            setWarehousesPagination(pagination || undefined);
            setResultCount(pagination?.totalItemCount || 0);
            setDefaultRadius(defaultRadius);
            setRadiusSearchFilter(defaultRadius);
            // Starter Removed - setMapCenter
            setWarehouses(warehouses || []);
            setIsLoading(false);
            /* Starter Custom Code - End */
        } else {
            setIsLoading(true);
        }
    }, [warehousesDataView, isGoogleMapsScriptsLoaded]);

    // Manage modal focus when tabbing through the map insert
    const keysPressed = {
        shift: false,
        tab: false,
    };

    let focusableElementInterval: any = null;

    const updateLastFocusableElement = () => {
        const focusableElements = document.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        );
        if (focusableElements.length > 0) {
            lastFocusableElement = focusableElements[focusableElements.length - 1];
        }
    };

    const handleKeydownTabInModal = (event: KeyboardEvent) => {
        // collect what keys are being pressed in the case that the user is trying to shift+tab while on the close modal button
        if (event.key === "Tab") {
            keysPressed.tab = true;
        } else if (event.key === "Shift") {
            keysPressed.shift = true;
        }
        // if straight tab and on the final focusable element (the terms of use html page link) refocus onto the close modal button
        if (event.key === "Tab" && !keysPressed.shift) {
            const currentElement = document.activeElement;
            // using the .html here as it is the only link on the page to an html page. Cannot rely on checking "terms of use" is the inner HTML since that will not always be in English

            if (currentElement === lastFocusableElement) {
                event.preventDefault();
                document.getElementById("CloseModalButton")?.focus();
            }
        } else if ((event.key === "Tab" && keysPressed.shift) || (event.key === "Shift" && keysPressed.tab)) {
            // if pressing shift+tab and the focus is on the close modal button, send the focus to the terms of use element which is the last anchor tag on the google map
            if (document.activeElement?.id === "CloseModalButton" && lastFocusableElement) {
                event.preventDefault();
                lastFocusableElement.focus();
            }
        }
    };

    const handleKeyupTabInModal = (event: KeyboardEvent) => {
        if (event.key === "Tab") {
            keysPressed.tab = false;
        } else if (event.key === "Shift") {
            keysPressed.shift = false;
        }
    };

    useEffect(() => {
        if (modalIsOpen && !warehouseHoursToDisplayModalOpen) {
            window.addEventListener("keydown", handleKeydownTabInModal);
            window.addEventListener("keyup", handleKeyupTabInModal);
            focusableElementInterval = setInterval(updateLastFocusableElement, 1000);
        }
        return () => {
            window.removeEventListener("keydown", handleKeydownTabInModal);
            window.removeEventListener("keyup", handleKeyupTabInModal);
            clearInterval(focusableElementInterval);
        };
    }, [modalIsOpen, warehouseHoursToDisplayModalOpen]);

    const modalCloseHandler = () => {
        onModalClose();
    };

    const handleDistanceUnitOfMeasureChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value as DistanceUnitOfMeasure;
        setDistanceUnitOfMeasure(value);
    };

    const handleOpenHoursModal = (warehouse: WarehouseModel) => {
        setWarehouseHoursToDisplayModalOpen(!!warehouse.hours);
        setWarehouseHoursToDisplay(warehouse);
    };

    const handleHoursModalClose = () => {
        setWarehouseHoursToDisplayModalOpen(false);
        setWarehouseHoursToDisplay(undefined);
    };

    const generateOpenWarehouseHoursFor = (warehouse: WarehouseModel) => {
        return () => handleOpenHoursModal(warehouse);
    };

    const generateWarehouseSelectClickHandler = (warehouse: WarehouseModel) => {
        return () => onWarehouseSelected(warehouse);
    };

    const isNotFinalResult = (resultIndex: number) => {
        if (!warehousesPagination) {
            return false;
        }
        return warehousesPagination.pageSize > resultIndex + 1;
    };
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        if (!isLoading) {
            /* Starter Custom Code - Start */
            const locationChanged = warehouseSearch && warehouseSearch !== warehouseSearchFilter;
            const radiusNumber = Number(radiusSearch);
            const radiusChanged =
                (!radiusNumber && radiusSearchFilter !== settingsRadiusRef.current) ||
                (radiusNumber && radiusNumber !== radiusSearchFilter);

            if (radiusChanged) {
                setRadiusSearchFilter(radiusNumber);
            }

            if (locationChanged || radiusChanged) {
                doSearch(warehouseSearch);
            }
            /* Starter Custom Code - End */
        }
    };
    const handleSearchRadiusChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRadiusSearch(event.target.value); // Starter Custom Code
    };

    return (
        <Modal
            {...styles.modal}
            headline={translate("Select Pick Up Location")}
            isOpen={modalIsOpen}
            handleClose={modalCloseHandler}
        >
            {/* Starter Moved - Grid - down */}
            <StyledForm {...styles.form} onSubmit={handleSubmit}>
                <SearchLocationsTextField
                    styles={styles.searchTextField}
                    warehouseSearchFilter={warehouseSearch} // Starter Custom Code
                    setWarehouseSearchFilter={setWarehouseSearch} // Starter Custom Code
                    onBlur={handleSearchWarehouseBlur} // Starter Custom Code
                />
                <TextField
                    {...styles.searchRadiusText}
                    label={translate("Search Radius ({0})", translate("Miles"))} // Starter Custom Code
                    value={radiusSearch} // Starter Custom Code
                    onChange={handleSearchRadiusChanged}
                    type="number"
                    min={0}
                    // Starter Removed - placeholder
                />
                <InlineFormButton /* Starter Custom Code */
                    {...styles.searchButton}
                    type="submit"
                    data-test-selector="findLocationModal_searchButton"
                >
                    {translate("Search")}
                </InlineFormButton>
            </StyledForm>
            <GridContainer {...styles.modalContent} data-test-selector="findLocationModal">
                <GridItem {...styles.leftColumnGridItem}>
                    <StyledWrapper {...styles.searchResultsHeader} /* Starter Custom Code */>
                        <Typography {...styles.searchResultsText}>
                            {/* Starter Custom Code - Start */}
                            {(resultCount === 1 ? translate("{0} Result") : translate("{0} Results")).replace(
                                "{0}",
                                `${resultCount}`,
                            )}
                            {/* Starter Custom Code - End */}
                        </Typography>
                        <RadioGroup
                            {...styles.distanceUnitOfMeasureRadioGroup}
                            value={distanceUnitOfMeasure}
                            onChangeHandler={handleDistanceUnitOfMeasureChange}
                            label={translate("Select distance unit")} // Starter Custom Code
                        >
                            <Radio {...styles.distanceUnitOfMeasureImperialRadio} value="Imperial">
                                {translate("Miles")}
                            </Radio>
                            <Radio {...styles.distanceUnitOfMeasureMetricRadio} value="Metric">
                                {translate("Kilometers")}
                            </Radio>
                        </RadioGroup>
                    </StyledWrapper>
                    {!isLoading && !locationKnown && (
                        <Typography {...styles.siteMessageGeocodeErrorText}>
                            {siteMessage("PickUpLocation_GeocodeErrorMessage")}
                        </Typography>
                    )}
                    {!isLoading && locationKnown && warehouses.length === 0 && (
                        <Typography
                            data-test-selector="findLocationModal_noresult"
                            {...styles.siteMessageResultsErrorText}
                        >
                            {showSelectedWarehouse
                                ? siteMessage("PickUpLocation_SelectedLocationIsOnlyResult")
                                : siteMessage("PickUpLocation_NoResultsMessage")}
                        </Typography>
                    )}
                    {(!warehousesDataView || !warehousesDataView.value) && <Loader /> /* Starter Custom Code */}
                    {warehousesDataView &&
                        warehousesDataView.value &&
                        warehouses.map((warehouse, index) => (
                            <StyledWrapper /* Starter Custom Code */
                                key={warehouse.id}
                                {...styles.warehouseWrapper}
                                data-test-selector="findLocationModal_warehouse"
                                data-test-key={`${warehouse.id}`}
                            >
                                {/* Starter Custom Code - Start */}
                                <Typography {...styles.warehouseDisplayNumberText}>
                                    <MarkerIcon text={getWarehouseNumber(index).toString()} />
                                </Typography>
                                <StyledWrapper {...styles.warehouseInfoWrapper}>
                                    <StyledWrapper {...styles.warehouseNameWrapper}>
                                        <Typography
                                            {...styles.warehouseNameText}
                                            data-test-selector={`pickUpLocationModal_warehouseName_${index}`}
                                        >
                                            {warehouse.description || warehouse.name}
                                        </Typography>
                                        <DistanceDisplay
                                            {...styles.warehouseDistanceDisplayText}
                                            distance={warehouse.distance}
                                            unitOfMeasure={distanceUnitOfMeasure}
                                            data-test-selector={`pickUpLocationModal_warehouseDistance_${index}`}
                                        />
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.warehouseAddressWrapper}>
                                        <AddressInfoCondensedDisplay
                                            {...styles.warehouseAddressInfoCondensed}
                                            {...warehouse}
                                        />
                                        {warehouse.phone && (
                                            <Link
                                                href={`tel:${warehouse.phone}`}
                                                {...styles.searchResultPhoneLink}
                                                target="_blank"
                                            >
                                                {warehouse.phone}
                                            </Link>
                                        )}
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.warehouseActionsWrapper}>
                                        {warehouse.hours && (
                                            <WarehouseHoursLink
                                                {...styles.warehouseHoursLink}
                                                warehouse={warehouse}
                                                onOpenWarehouseHours={generateOpenWarehouseHoursFor(warehouse)}
                                                data-test-selector={`pickUpLocationModal_warehouseHours_${index}`}
                                            />
                                        )}
                                        <GoogleMapsDirectionLink
                                            {...styles.warehouseGoogleMapsDirectionLink}
                                            {...warehouse}
                                        />
                                    </StyledWrapper>
                                    <StyledWrapper>
                                        {warehouse.id === selectedWarehouse?.id ? (
                                            <InfosBox {...styles.currentLocationInfoBox}>
                                                {translate("Current Pick Up Location")}
                                            </InfosBox>
                                        ) : (
                                            <Button
                                                {...styles.searchResultSelectButton}
                                                type="button"
                                                onClick={generateWarehouseSelectClickHandler(warehouse)}
                                                data-test-selector="findLocationModal_warehouseSelect"
                                            >
                                                {translate("Select as Pick Up Location")}
                                            </Button>
                                        )}
                                    </StyledWrapper>
                                </StyledWrapper>
                                {/* Starter Custom Code - End */}
                            </StyledWrapper>
                        ))}
                    <WarehouseFindLocationPagination
                        {...styles.pagination}
                        warehouses={warehouses}
                        warehousesPagination={warehousesPagination}
                        setPage={setPage}
                        setPageSize={setPageSize}
                    />
                </GridItem>

                <GridItem {...styles.rightColumnGridItem}>
                    {/* Starter Removed - entire "selectedWarehouse" Grid */}
                    <StyledWrapper {...styles.mapWrapper} /* Starter Custom Code */>
                        <WarehouseGoogleMap
                            extendedStyles={styles.warehouseGoogleMap}
                            currentLocation={currentLocation}
                            warehouseSearchFilter={warehouseSearchFilter}
                            distanceUnitOfMeasure={distanceUnitOfMeasure}
                            setGoogleMap={setGoogleMap}
                            mapMarkerElements={mapMarkersElements}
                            warehouseInfoWindow={warehouseInfoWindow}
                            currentLocationInfoWindow={currentLocationInfoWindow}
                            handleOpenWarehouseHours={handleOpenHoursModal}
                            updateLastFocusableElement={updateLastFocusableElement}
                        />
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
            <Modal
                {...styles.warehouseHoursModal}
                headline={translate("Hours")}
                isOpen={warehouseHoursToDisplayModalOpen}
                handleClose={handleHoursModalClose}
            >
                <StyledWrapper {...styles.hoursContainer}>
                    {parse(warehouseHoursToDisplay?.hours || "", parserOptions)}
                </StyledWrapper>
            </Modal>
        </Modal>
    );
};

interface SearchLocationsTextFieldProps {
    styles?: TextFieldPresentationProps;
    warehouseSearchFilter: string;
    setWarehouseSearchFilter: (filter: string) => void;
    // Starter Custom Code
    onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchLocationsTextField = ({
    styles,
    warehouseSearchFilter,
    setWarehouseSearchFilter,
    // Starter Custom Code
    onBlur,
}: SearchLocationsTextFieldProps) => {
    const handleSearchLocationsChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setWarehouseSearchFilter(event.target.value);
    };

    return (
        <TextField
            {...styles}
            label={translate("Search by Postal Code, City, Province or Country")} // Starter Custom Code
            value={warehouseSearchFilter}
            onChange={handleSearchLocationsChanged}
            // Starter Removed - placeholder
            data-test-selector="findLocationModal_locationSearch"
            onBlur={onBlur} // Starter Custom Code
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withDynamicGoogleMaps(FindLocationModal));
